export default __webpack_public_path__ + "static/media/health.c6823bf2.svg";